import * as ko from 'knockout';

import { ListRequestParams } from '../api/request';
import { ListLoaderDelegate, delegateActions } from '../components/list_loader';
import { Project } from '../models/project';
import { session } from '../session';
import { ProjectData, projectApi } from '../api/projects';
import { addChangelogListAction, addChangelogAction } from './changelog';
import { Action } from '../components/basic_widgets';
import i18n from '../i18n';
import { canViewChangelog, reactListTablesEnabled } from '../permissions';
import { tryFormatDate } from '../utils';
import { GridView } from '../utils/grid_view';
import { ProgramsListPage, ProgramsListProps, ProgramsListQuery, ProgramsListRow } from 'react-islands';

let template = require('raw-loader!../../templates/projects.html').default;

class ProjectsScreen implements ListLoaderDelegate<ProjectData, Project> {
  canCreate = session.isAtLeastEditor();
  // Same rule as the legacy user-log columns.
  showUserLog = canViewChangelog(null);

  listActions = addChangelogListAction(
    'project',
    this.canCreate ? [{ title: i18n.t('Add')(), icon: 'add_circle', href: '/projects/new/' }] : []
  );

  newProgramsTable = reactListTablesEnabled();

  private view = new GridView('programs');

  tableProps = ko.pureComputed<ProgramsListProps>(() => ({
    view: this.view,
    fetchPage: this.fetchPage,
    showUserLog: this.showUserLog,
  }));

  constructor(params: { filters: unknown }) {
    if (this.newProgramsTable) {
      this.view.load(params.filters);
    }
  }

  fetch(params: ListRequestParams) {
    return projectApi.list(params);
  }

  private fetchPage = (query: ProgramsListQuery): Promise<ProgramsListPage> =>
    this.view.fetchListPage(query, projectApi.list, 'name_prefix', this);

  toRow = (project: Project, data: ProjectData): ProgramsListRow => ({
    id: project.id(),
    name: project.name(),
    url: session.toTenantPath(project.editUrl),
    fromDate: tryFormatDate(project.fromDate()),
    toDate: tryFormatDate(project.toDate()),
    createdByName: data.created_by_user_name || '',
    modifiedByName: data.modified_by_user_name || '',
    actions: delegateActions(this, project, this.view.reload),
  });

  instantiate(data: ProjectData) {
    return new Project(data);
  }

  getName(entity: Project) {
    return entity.name();
  }

  getEditUrl(entity: Project) {
    return entity.editUrl;
  }

  remove(id: string) {
    return projectApi.remove(id);
  }

  canRemove(entity: Project) {
    return entity.canEdit();
  }

  getActions(entity: Project): Action[] {
    return addChangelogAction('project', entity.id());
  }
}

export let projects = {
  name: 'projects',
  viewModel: ProjectsScreen,
  template: template,
};

ko.components.register(projects.name, projects);
